import { render } from "./AnnouncementList.vue?vue&type=template&id=1311af12"
import script from "./AnnouncementList.vue?vue&type=script&lang=js"
export * from "./AnnouncementList.vue?vue&type=script&lang=js"
script.render = render

export default script